import { render } from "./permisitionsComponent.vue?vue&type=template&id=aef2b2fc&scoped=true"
import script from "./permisitionsComponent.vue?vue&type=script&lang=js"
export * from "./permisitionsComponent.vue?vue&type=script&lang=js"

import "./permisitionsComponent.vue?vue&type=style&index=0&id=aef2b2fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef2b2fc"]])

export default __exports__